import { render, staticRenderFns } from "./HistoryDynamicBloodOxygen2.vue?vue&type=template&id=0b5405a0&scoped=true&"
import script from "./HistoryDynamicBloodOxygen2.vue?vue&type=script&lang=js&"
export * from "./HistoryDynamicBloodOxygen2.vue?vue&type=script&lang=js&"
import style0 from "./HistoryDynamicBloodOxygen2.vue?vue&type=style&index=0&id=0b5405a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5405a0",
  null
  
)

export default component.exports